import { useQuery } from '@tanstack/react-query';

import { storesApi } from '../api/stores-api';
import { supportedTimeZones } from '../schemas/timezones';

import { storeKeys } from './store-keys';

/**
 * The zones the backend accepts. Until they arrive (or if the call fails) the browser's own list
 * stands in, so the picker never renders empty.
 */
export function useTimeZones(): readonly string[] {
  const query = useQuery({
    queryKey: storeKeys.timezones(),
    queryFn: storesApi.timezones,
    staleTime: Infinity,
    meta: { silentError: true },
  });
  return query.data ?? supportedTimeZones();
}
